export class FORMJOBDATA {
  file: File;
  name: string;
  mobileNumber: string;
  emailId: string;
  positionApplied: string;
  message: string;
}
